export const defaultValues = {
  infoId: '',
  dentalId: '',
  period: '',
  siren: '',
  managementSoftware: [],
  surfaceSqm: '',
  chairCount: '',
  dentistCount: '',
  collabDentistCount: '',
  chairsideAssistantCount: '',
  hasEmployedProsthetist: false,
  hasRadio2d: false,
  hasRadio3d: false,
  hasSalesAssistant: false,
  hasSecretarialAssistant: false
};
